<template>
    <div class="title_s">Raportet</div>
    <div class="text">Në punim e sipër...</div>
</template>